import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import redux from '../../redux';

type HostManagerProps = {
  currentCustomerGroupUuid: string;
  host: string;
};

function HostManager({ currentCustomerGroupUuid, host }: HostManagerProps) {
  const dispatch: typeof redux.store.dispatch = useDispatch();

  useEffect(() => {
    dispatch(redux.api.setHost(host));
    dispatch(redux.api.setCurrentCustomerGroupUuid(currentCustomerGroupUuid));
  }, [host, currentCustomerGroupUuid]);

  return null;
}

export default HostManager;
